import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type de catégorie ", -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Lien ", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Sous catégorie ", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image ", -1)
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Ajouter ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_28 = {
  class: "modal fade createNewModal",
  id: "AddImageModal",
  tabindex: "-1",
  ref: "addAddImageModalRef",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_30 = { class: "modal-content p-15 p-md-40" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, " Image actuelle")
], -1)
const _hoisted_32 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25 text-center" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          ref: "categorieArticleForm",
          onSubmit: _ctx.addCategorieArticle,
          "validation-schema": _ctx.categorieArticleSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Field, {
                    name: "nom",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le nom"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "nom",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_Field, {
                    name: "typeCategorie",
                    modelValue: _ctx.typeDefault,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeDefault) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.typeCategorieOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner le type de catégorie" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "typeCategorie",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    name: "lienExterne",
                    type: "text",
                    ref: "",
                    placeholder: "Entrer le lien",
                    class: "form-control shadow-none rounded-0 text-black"
                  }, null, 512),
                  _createVNode(_component_ErrorMessage, {
                    name: "lienExterne",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_Field, { name: "categorieArticle" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.categorieOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner la catégorie" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "categorieArticle",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Field, {
                    name: "urlImage",
                    type: "file",
                    accept: "image/jpeg, image/png",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Choisir une image"
                  })
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "urlImage",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_Field, {
                    name: "description",
                    as: "textarea",
                    cols: "30",
                    rows: "12",
                    placeholder: "Ecrire votre message",
                    class: "form-control shadow-none rounded-0 text-black"
                  }, {
                    default: _withCtx(({ field}) => [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, null, 8, _hoisted_22), [
                        [_vModelText, field.value]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "description",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_router_link, {
                    to: "/liste-categorieArticles",
                    class: "btn btn-danger transition border-0 lh-1 fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _hoisted_27,
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (_ctx.categorie?.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getUrlApiForFiles(_ctx.categorie?.urlImage),
                  alt: "Image",
                  width: "300",
                  height: "300"
                }, null, 8, _hoisted_33))
              : (_openBlock(), _createElementBlock("h3", _hoisted_34, "Aucune image"))
          ]),
          _hoisted_35
        ])
      ])
    ], 512)
  ], 64))
}